// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-empty-index-module__ui-empty-EswYWy {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-bottom: 5%;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-empty-index-module__ui-empty-EswYWy .semi-empty-content {
  margin-top: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-empty-index-module__ui-empty-EswYWy .semi-empty-title {
  font-size: 16px !important;
}

.\\------packages-components-bot-semi-src-components-ui-empty-index-module__ui-empty-EswYWy .semi-empty-description {
  font-size: 14px;
}

.\\------packages-components-bot-semi-src-components-ui-empty-index-module__ui-empty-EswYWy .semi-empty-title + .semi-empty-description {
  margin-top: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-empty-index-module__ui-empty-EswYWy .semi-empty-footer {
  justify-content: center;
  display: flex;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-empty": `------packages-components-bot-semi-src-components-ui-empty-index-module__ui-empty-EswYWy`,
	"uiEmpty": `------packages-components-bot-semi-src-components-ui-empty-index-module__ui-empty-EswYWy`
};
export default ___CSS_LOADER_EXPORT___;
